/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

function getDentalFeeFunctionConfig() {
  const dental_fee__total_cost__value = (values, defaultValue) => {
    if (
      !values.goverment_dental_expenses &&
      !values.private_tartar_scaling_cost &&
      !values.private_cost_of_tooth_filling_and_tooth_extraction &&
      !values.private_other_dental_expense
    )
      return 0
    return Math.floor(
      (values.goverment_dental_expenses || 0) +
        (values.private_tartar_scaling_cost || 0) +
        (values.private_cost_of_tooth_filling_and_tooth_extraction || 0) +
        (values.private_other_dental_expense || 0),
    )
  }

  const dental_fee__goverment_dental_calculation__value = (values, defaultValue) => {
    if (values.hospital_type === 'โรงพยาบาลเอกชน') return 0
    return Math.floor(values.goverment_dental_expenses || 0)
  }

  const dental_fee__private_dental_calculation__value = (values, defaultValue, user) => {
    const { dentalBudget } = user
    if (
      !values.private_tartar_scaling_cost &&
      !values.private_cost_of_tooth_filling_and_tooth_extraction &&
      !values.private_other_dental_expense
    )
      return 0
    const requestForMyself = values.patient === 'self' ? 1 : 0 // change 70% to 100% at 10/9/2024
    const calculation =
      (values.private_tartar_scaling_cost || 0) +
      (values.private_cost_of_tooth_filling_and_tooth_extraction || 0) +
      (values.private_other_dental_expense || 0)
    const autoCalValue = Math.floor(calculation * requestForMyself)
    if (autoCalValue >= dentalBudget) return dentalBudget
    return autoCalValue
  }

  const dental_fee__goverment_dental_expenses__disabled = (values, defaultValue) => {
    if (values.hospital_type === 'โรงพยาบาลเอกชน') return true
    return false
  }
  const dental_fee__goverment_dental_expenses__value = (values, defaultValue) => {
    if (values.hospital_type === 'โรงพยาบาลเอกชน') return 0
    return values.goverment_dental_expenses || 0
  }

  const dental_fee__all_permissions_calculated__value = (values, defaultValue) => {
    if (!values.goverment_dental_calculation && !values.private_dental_calculation) return 0
    return Math.floor((values.goverment_dental_calculation || 0) + (values.private_dental_calculation || 0))
  }

  const dental_fee__total_approve__value = (values, defaultValue) => {
    if (!values.goverment_dental_approve && !values.private_dental_approve) return 0
    return Math.floor((values.goverment_dental_approve || 0) + (values.private_dental_approve || 0))
  }

  const validate = (values, defaultValue) => {
    return true
  }

  const dental_fee__goverment_dental_approve__value = (values, defaultValue) => {
    if (values.hospital_type === 'โรงพยาบาลเอกชน') return 0
    return Math.floor(values.goverment_dental_expenses) || 0
  }

  const dental_fee__private_dental_approve__value = (values, defaultValue, user) => {
    const { dentalBudget } = user
    const autoCalValue = values.private_dental_calculation
    if (autoCalValue) {
      return autoCalValue >= dentalBudget ? dentalBudget : autoCalValue
    }
    return 0
  }

  const dental_fee__private_tartar_scaling_cost__value = (values, defaultValue) => {
    return 0
  }

  const dental_fee__private_cost_of_tooth_filling_and_tooth_extraction__value = (values, defaultValue) => {
    return 0
  }

  const dental_fee__private_other_dental_expense__value = (values, defaultValue) => {
    return 0
  }

  const dentalFeeBudget = (context) => {
    const { values, remainingDentalBudget } = context
    const inputValues = values.inputs
    const dentalFeeApproval = inputValues['private_dental_approve']
    const budgetAmount = remainingDentalBudget - Math.floor(dentalFeeApproval.replaceAll(',', ''))
    if (budgetAmount < 0) return false
    return true
  }

  const cleaningOnceAYear = async (context) => {
    const { values, requestId, requester, queryRunner, requestName } = context
    const inputValues = values.inputs
    const patient = inputValues['patient']
    const patientName = patient === 'self' ? `${requester.firstName || ''} ${requester.lastName || ''}` : patient?.name
    const requestIdValue = requestId !== undefined ? `'${requestId}'` : 'NULL'
    const disease = inputValues['disease'] !== 'ขูดหินปูน'
    const hospitalType = inputValues['hospital_type'] !== 'โรงพยาบาลเอกชน'
    const receiptYear = inputValues['receipt_date']?.split('/')[2]

    if (disease || hospitalType) {
      return true
    }

    const stringQuery = `SELECT
        COUNT(*) as count
      FROM
          bam.claim_requests AS c
      INNER JOIN
          bam.employees AS e ON c.employee_id = e.id
      CROSS JOIN LATERAL
          (SELECT JSONB_EXTRACT_PATH_TEXT(c.info, 'values', 'inputs', 'patient') AS value) AS patient
      CROSS JOIN LATERAL
          (SELECT JSONB_EXTRACT_PATH_TEXT(c.info, 'values', 'inputs', 'patient', 'name') AS value) AS patient_name
      CROSS JOIN LATERAL
          (SELECT JSONB_EXTRACT_PATH_TEXT(c.info, 'values', 'inputs', 'disease') AS value) AS disease
      CROSS JOIN LATERAL
          (SELECT JSONB_EXTRACT_PATH_TEXT(c.info, 'values', 'inputs', 'hospital_type') AS value) AS hospital_type
      CROSS JOIN LATERAL
          (SELECT e.firstname || ' ' || e.lastname AS value) AS employee_name
      CROSS JOIN LATERAL
          (SELECT JSONB_EXTRACT_PATH_TEXT(c.info, 'values', 'inputs', 'receipt_date') AS value) AS receipt_date
      CROSS JOIN LATERAL
          (SELECT to_char(to_date(receipt_date.value,'DD-MM-YYYY'), 'YYYY') AS value) AS year    
      WHERE
        c.type = '${requestName}'
        AND (c.status = 'WAITING' OR c.status = 'APPROVED')
        AND (${requestIdValue} IS NULL OR c.id != ${requestIdValue})
        AND (
          (patient.value IS NULL)
          OR
          (patient.value = 'self' AND employee_name.value = '${patientName}')
          OR
          (patient.value != 'self' AND patient_name.value = '${patientName}')
        )
        AND disease.value = 'ขูดหินปูน'
        AND hospital_type.value = 'โรงพยาบาลเอกชน'
        AND year.value = '${receiptYear}'      
        `
    const queryClaimRequest = await queryRunner.query(stringQuery)
    const countClaimRequest = parseInt(queryClaimRequest[0].count)

    return countClaimRequest === 0
  }

  const dental_fee__claim_year__value = (values) => {
    if (values.receipt_date) return new Date(values.receipt_date).getFullYear().toString()
    return undefined
  }

  const dental_fee__not_covered_amount__value = (values) => {
    const amountStr = values.bill_total_cost?.toString().replaceAll(',', '')
    const totalApproveStr = values.total_approve?.toString().replaceAll(',', '')
    const amount = parseInt(amountStr)
    const totalApprove = parseInt(totalApproveStr)
    const result = amount - totalApprove
    return result < 0 ? 0 : result
  }

  return {
    autoCal: {
      // ..AutoCal
      dental_fee__total_cost__value,
      dental_fee__goverment_dental_calculation__value,
      dental_fee__private_dental_calculation__value,
      dental_fee__all_permissions_calculated__value,
      dental_fee__total_approve__value,
      dental_fee__goverment_dental_expenses__disabled,
      dental_fee__goverment_dental_expenses__value,
      dental_fee__goverment_dental_approve__value,
      dental_fee__private_dental_approve__value,
      dental_fee__private_tartar_scaling_cost__value,
      dental_fee__private_cost_of_tooth_filling_and_tooth_extraction__value,
      dental_fee__private_other_dental_expense__value,
      dental_fee__claim_year__value,
      dental_fee__not_covered_amount__value,
    },
    validate: {
      // ...validate
      validate,
      dentalFeeBudget,
      cleaningOnceAYear,
    },
  }
}
